// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    identifier: 'golf-one',
    ANALYTIC_ENDPOINT: 'https://bleachr-analytics-dev.herokuapp.com/events',
    GOLF_ONE_ACCOUNT_ID: '21553dea-e89c-4b8c-9397-6801e53957b9',
    ELIXIR_API_FOUR: 'https://fan-engine-dev.herokuapp.com/api/v4',
    ELIXIR_API_THREE: 'https://fan-engine-dev.herokuapp.com/api/v3',
    ELIXIR_SOCKET_HOST: 'wss://fan-engine-dev.herokuapp.com',
    GOOGLE_CLIENT_ID: '721229795292-fabeedl95aaefq9bdev0ber3g3n55q6d.apps.googleusercontent.com',
    GOOGLE_REDIRECT: 'https://tennis-one-dev.herokuapp.com/return',
    GOOGLE_OAUTH_URI: 'https://accounts.google.com/o/oauth2/v2/auth',
    BLEACHR_CHAT_SOCKET: 'wss://bleachr-chat-dev.herokuapp.com/socket',
    BLEACHR_WEB_API: 'https://bleachr-web-api-dev.herokuapp.com/api',
    BRACKET_BATTLE: 'https://bleachr-bracket-battle-dev.herokuapp.com',
    CROWD_VIEW_LIVE_URL: 'https://bleachr-crowdview-dev.herokuapp.com',
    WEBCLIENT_URL: 'https://bleachr-webclient-dev.herokuapp.com',
    RECAPTCHA_SITE_KEY: '6LfHTlMrAAAAAKDrJ2vY65jUC3MPIInjLllWvVrd',
    RECAPTCHA_SECRET_KEY: '6LfHTlMrAAAAAI1hmqOMcKRZ_GjyZIF173nx38iO',
    NOW_TIMELINE_ID: '2d94e2a3-0627-47db-ae9f-0a004e6db0a6',    // TODO: Use GolfONE ID
    APP_TITLE: 'GolfONE DEV',
    NEWS_HOST: 'https://dev.news.golfoneapp.com',
    RECAPTCHA_API_KEY: "6LdeIB4sAAAAAJr-b2Tgwa3qimITzJNMZDbvnmt3"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
